<template>
  <v-container fluid class="d-inline-flex justify-end">
    <div>
      <v-btn-toggle
        v-model="currency"
        mandatory
        dense
      >
        <v-btn>
          ₡
        </v-btn>
        <v-btn>
          $
        </v-btn>
      </v-btn-toggle>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ExchangeRate',
  data () {
    return {
      typeCurrency: [
        'CRC',
        'USD'
      ]
    }
  },
  methods: {
    ...mapMutations(['setCurrency']),
    ...mapActions([])
  },
  computed: {
    currency: {
      get () {
        return this.typeCurrency.findIndex((cur) => cur === this.$store.state.currentCurrency)
      },
      set (value) {
        this.$store.commit('setCurrency', this.typeCurrency[value])
      }
    },
    ...mapGetters([]),
    ...mapState([])
  }
}
</script>
